import { render, staticRenderFns } from "./HomeSettingsDiacriticsComponent.vue?vue&type=template&id=1f6f3272&scoped=true&"
import script from "./HomeSettingsDiacriticsComponent.vue?vue&type=script&lang=js&"
export * from "./HomeSettingsDiacriticsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeSettingsDiacriticsComponent.vue?vue&type=style&index=0&id=1f6f3272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f3272",
  null
  
)

export default component.exports